@import 'src/vars';

.width-wrapper-component {
  max-width: 1366px;
  padding-left: 30px;
  padding-right: 30px;
  margin: 0 auto;

  @media only screen and (max-width: $mobile_break) {
    padding: 0 15px;
  }

  &.soft {
    background-color: var(--gray_light2);
  }
}
